import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState, useProductFilters } from "@nosto/preact"
import { useEffect } from "preact/hooks"


export default function Products() {
    const {
        response: { products },
        loading
    } = useAppState()

    const { filters, removeAll } = useProductFilters()



        useEffect(()=>{
            /*function checkJquery(){
                if(typeof jQuery === "function"){
                    jQuery(".modal.header-search-modal.modal--transparent").trigger("click");
                    jQuery("header").addClass("header header--sticky header--dark");
                    setInterval(function(){
                        jQuery("header").removeClass("header--transparent header--light");
                    },100)
                    jQuery("html").removeClass("modal-search-open modal-search-dropdown-active scroll-lock");
                    jQuery("body").removeClass();
        
                    jQuery(".modal.header-search-modal").remove();
        
                    let heightFromTop = jQuery(".header__logo-wrapper").outerHeight() + jQuery("header").outerHeight();
                    // if(window.outerWidth > 768) jQuery(".ns-serp").attr("style", `margin-top: ${heightFromTop}px !important`);
        
                    jQuery(".header-search-modal").remove();
        
                    ReloadSmartWishlist();
        
                    // removing the native "Refine" button on Search
                    jQuery(".results-navbar__row button").remove();
                 }else{
                  setTimeout(checkJquery, 1000);
                }
              }
              checkJquery();
              */
             // Simulate a click on the modal
                document.querySelector(".modal.header-search-modal.modal--transparent")?.click();

                // Add multiple classes to <header>
                document.querySelector("header")?.classList.add("header", "header--sticky", "header--dark");

                // Remove specific classes from <header> after 100ms
                setInterval(() => {
                    document.querySelector("header")?.classList.remove("header--transparent", "header--light");
                }, 100);

                // Remove classes from <html>
                document.documentElement.classList.remove("modal-search-open", "modal-search-dropdown-active", "scroll-lock");

                // Remove all classes from <body>
                document.body.className = "";

                // Remove the modal
                document.querySelector(".modal.header-search-modal")?.remove();

                // Calculate the height from the top
                const logoHeight = document.querySelector(".header__logo-wrapper")?.offsetHeight || 0;
                const headerHeight = document.querySelector("header")?.offsetHeight || 0;
                const heightFromTop = logoHeight + headerHeight;

                // Uncomment the following line if needed
                // if (window.outerWidth > 768) {
                //     document.querySelector(".ns-serp")?.setAttribute("style", `margin-top: ${heightFromTop}px !important`);
                // }

                // Remove the search modal
                document.querySelector(".header-search-modal")?.remove();

                // Call the function ReloadSmartWishlist()
                if (typeof ReloadSmartWishlist === "function") {
                    ReloadSmartWishlist();
                }

                // Remove all <button> elements inside .results-navbar__row
                document.querySelectorAll(".results-navbar__row button").forEach(button => button.remove());

            
        })

    return (
        <ul class="results-grid list-inline" data-grid="" data-results-grid="">
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </ul>
    )
}
